var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignCityEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_city_x5F_eu_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_city_x5F_back_x5F_eu"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2B236"
    },
    d: "M90,82H6c-2.209,0-4-1.791-4-4V18c0-2.209,1.791-4,4-4h84c2.209,0,4,1.791,4,4v60 C94,80.209,92.209,82,90,82z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90,18v60H6V18H90 M90,16H6c-1.105,0-2,0.895-2,2v60c0,1.105,0.895,2,2,2h84c1.105,0,2-0.895,2-2V18 C92,16.895,91.105,16,90,16L90,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignCityEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_city_eu.f271c9342299ef7f78039c2fa6292407.svg";
export { ForwardRef as ReactComponent };